import View from "./View";

const AddButton = View.extend(
  /** @lends AddButton.prototype */
  {
    /**
     * Simple view for the "+" button for invoking file selection dialog
     * @param {UploaderModel} model
     * @param {object} opts
     * @constructs
     * @extends View
     */
  constructor(model, opts) {
    View.call(this, model, opts);

    this.setHTML(this.opts.template.parse("add_items", {
      id: this.id,
      enable_capture: this.opts.enable_capture
    }));
  },

  onMount() {
    const btnEl = this.getElement("add_button");
    this.forwardEvent(btnEl, "click");

    const captureBtnEl = this.getElement("capture_button");
    if (captureBtnEl) this.forwardEvent(captureBtnEl, "click", "capture");
  }
});

export default AddButton;
